// 定义Method为常量对象，便于作为值使用
export const Method = {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE'
} as const

export const API = {
    // 获取医院床位数据
    getHospitalBedData: { method: Method.GET, url: '/xs/hospital-bed/getData' },
    // 获取今日预约数据
    getTodayAppointmentData: { method: Method.POST, url: '/xs/patient-apply/page' },
    // 申请入院接口
    applyForHospital: { method: Method.POST, url: '/xs/patient-apply/create' },
    // 获取字典
    getDepartmentList: { method: Method.GET, url: '/sys/dict-data/list' },
    // 获取病种
    getWardList: { method: Method.GET, url: '/xs/dict/list' },
    // 添加病种
    addConditionType: { method: Method.POST, url: '/xs/dict/create' },
    // 修改申请时间
    updateApplyTime: { method: Method.PUT, url: '/xs/patient-apply/updateApplyTime' },
    // 修改状态
    updateStatus: { method: Method.PUT, url: '/xs/patient-apply/updateStatus' },
    // 删除今日预约数据
    deleteTodayAppointment: { method: Method.DELETE, url: '/xs/patient-apply/delete' },

    // 修改预计入院时间
    updateYjInHospitalTime: { method: Method.PUT, url: '/xs/patient-apply/updateYjInHospitalTime' },
    // 查询床位
    getRemainBed: { method: Method.GET, url: '/xs/hospital-bed/getRemainBed' },
    // 预约详情
    getAppointmentDetail: { method: Method.GET, url: '/xs/patient-apply/get' },
    // 修改入院信息
    updatePatientApply: { method: Method.PUT, url: '/xs/patient-apply/update' },
    // 修改预计出院时间
    updateYjLeaveHospitalTime: { method: Method.PUT, url: '/xs/patient-bed/updateYjLeaveHospitalTime' },
    // 修改入院状态
    updateBedType: { method: Method.PUT, url: '/xs/patient-bed/update' },
    // 删除病种
    deleteConditionType: { method: Method.DELETE, url: '/xs/dict/delete' },
    // 修改重置
    updateResetPatient: { method: Method.PUT, url: '/xs/patient-apply/updateReset' },
    // 根据id查询患者列表
    selectPatientListById: { method: Method.GET, url: '/xs/patient-apply/selectPatientListById' },
    
}
